import React, { ReactChild } from "react";

import classNames from "classnames";

import { NavRoleType } from "../Nav";
import { StyledNavListItem } from "../Styles";

export interface ItemProps {
  /** Classname prop for custom styling. */
  children: ReactChild | string;
  /** Active state(underline). */
  active?: boolean;
  /** Disabled state. */
  disabled?: boolean;
  className?: string;
  name: string;
  role?: NavRoleType;
}

export const Item = React.forwardRef<
  HTMLLIElement,
  ItemProps & React.ComponentPropsWithoutRef<"li">
>(
  (
    { children, active = false, disabled = false, className, role, ...rest },
    ref
  ) => {
    return (
      <StyledNavListItem
        className={classNames(
          `c-nav__item`,
          {
            "c-nav__item--active": active,
          },
          className
        )}
        ref={ref}
        {...rest}
        $active={active}
        $disabled={disabled}
        $role={role}
      >
        {children}
      </StyledNavListItem>
    );
  }
);

Item.displayName = "Item";
